import type { FetchClient, RequestOptions } from '../../../lib/http/http.types';
import EmployeeEndpoints from '../../employees/api/employeeEndpoints';

export type ContractSettings = {
  /** Installation option "Contract activation" (`global.contratclosing='O'`). */
  contractActivationEnabled: boolean;
};

export function ContractSettingsApiFactory(client: FetchClient) {
  return {
    /** GET /employees/contract-settings → { contract_activation_enabled: boolean } */
    getContractSettings: (opts?: RequestOptions): Promise<ContractSettings> =>
      client
        .get<{ contract_activation_enabled?: boolean }>(EmployeeEndpoints.CONTRACT_SETTINGS, opts)
        .then(raw => ({ contractActivationEnabled: raw?.contract_activation_enabled === true })),
  };
}
